<template>
  <div class="scroll-table" ref="scrollTable" :style="{maxHeight: styleMaxHeight, height: height}">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watchEffect, onMounted, onBeforeUnmount, nextTick } from 'vue'

export default defineComponent({
  props:['reRendering', 'maxHeight', 'height'],
  setup(props) {
    const scrollTable = ref()
    const styleMaxHeight = ref((props.maxHeight) ? props.maxHeight : 0)

    const setMaxHeight = () => {      
      if (props.height) {
        styleMaxHeight.value = 'none'
        return
      }
      if (props.maxHeight) {
        styleMaxHeight.value = props.maxHeight
      } else if (scrollTable.value) {
        let height = 0;
        const top = scrollTable.value.getBoundingClientRect().top
        if (top > 0) {
          const wh = window.innerHeight
          const btn = document.getElementsByClassName('button-container')
          const footer = document.getElementsByTagName('footer')
          height = wh - top
          if (btn.length > 0) {
            height -= btn[0].getBoundingClientRect().height
          }
          if (footer.length > 0) {
            height -= footer[0].getBoundingClientRect().height
          }
        }
        styleMaxHeight.value = (height - 20) + 'px'
      }
    }

    onMounted(() => {
      window.addEventListener('resize', setMaxHeight, true)
      nextTick(() => {
        setTimeout(setMaxHeight, 0)
      })
    })

    watchEffect(() => {
      if (props.reRendering) {
        setTimeout(setMaxHeight, 0)
      }
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', setMaxHeight, true)
    })
    
    return {
      scrollTable,
      styleMaxHeight
    }
  }
})
</script>

<style scoped>

@media screen {
  .scroll-table {
    overflow: auto;
    position: relative;
    max-width: 100%;
  }
  .scroll-table ::v-deep(table thead) {
    position: sticky;
    top: 0;
    z-index: 10;
  }
  .scroll-table ::v-deep(table thead th) {
    white-space: nowrap;
  }
  .delete-table .scroll-table ::v-deep(table thead tr:first-child th:last-child) {
    background-color: #a5a4a4;
  }
}

@media print {  .scroll-table{
    max-height: none!important;
  }
}
</style>
